import { render, staticRenderFns } from "./OrderSent.vue?vue&type=template&id=c761d4d6"
import script from "./OrderSent.vue?vue&type=script&lang=js"
export * from "./OrderSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports